import { Component, ErrorInfo, ReactNode } from 'react';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[BO] [ERROR] ErrorBoundary caught:`, {
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className={styles.errorBoundary__wrapper}>
          <h2>Algo sali&oacute; mal</h2>
          <pre className={styles.errorBoundary__errorDetail}>
            {this.state.error?.message}
          </pre>
          <button
            className="btn-primary"
            onClick={() => { this.setState({ hasError: false, error: undefined }); window.location.reload(); }}
          >
            Recargar p&aacute;gina
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
